import { render, staticRenderFns } from "./AddProjectsDialog.vue?vue&type=template&id=45376848&scoped=true"
import script from "./AddProjectsDialog.vue?vue&type=script&lang=ts"
export * from "./AddProjectsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45376848",
  null
  
)

export default component.exports